module.exports = __webpack_public_path__ + "static/media/728_01.a7813fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/luckyclover/728_01.jpg
// module id = 669
// module chunks = 1